<script>
export default {
    props: {
        documents: Array
    },
    data() {
        return {
            currentCategory: null,
            currentYear: null,
            extendedCategories: {}
        };
    },
    watch: {
        currentCategory() {
            this.currentYear = null;
            this.extendedCategories = {};
        },
        currentYear() {
            this.extendedCategories = {};
        }
    },
    computed: {
        categories() {
            const categories = [];
            function idInArray(id, array) {
                return array.find((item) => item.id == id);
            }

            for (const document of this.documents) {
                if (!idInArray(document.category_id, categories)) {
                    categories.push({
                        id: parseInt(document.category_id),
                        title: document.category_title
                    });
                }
            }

            return categories;
        },
        years() {
            const years = this.documents.filter((document) => {
                return /*this.currentCategory == null ||*/ document.category_id == this.currentCategory;
            }).map((document) => {
                return parseInt(document.year);
            }).filter((value, index, array) => array.indexOf(value) === index).sort().reverse();

            return years;
        },
        filteredDocuments() {
            return this.documents.filter((document) => {
                return (/*this.currentCategory == null ||*/ document.category_id == this.currentCategory) && (this.years.length == 0 || /*this.currentYear == null ||*/ document.year == this.currentYear);
            });
        },
        filteredDocumentsByCategory() {
            const result = [];
            let currentCategoryId = null;
            let currentCategoryTitle = null;
            let currentCategory = [];

            for (const document of this.filteredDocuments) {
                if (currentCategoryId != parseInt(document.category_id)) {
                    if (currentCategoryId) {
                        result.push({
                            title: currentCategoryTitle,
                            isExpanded: false,
                            documents: currentCategory
                        });
                    }

                    currentCategoryId = document.category_id;
                    currentCategoryTitle = document.category_title;
                    currentCategory = [];
                }

                currentCategory.push(document);
            }

            if (currentCategoryId) {
                result.push({
                    title: currentCategoryTitle,
                    documents: currentCategory
                });
            }

            return result;
        }
    },
    methods: {
        getCategoryDocuments(category) {
            if (this.extendedCategories[category.id]) {
                return category.documents;
            } else {
                return category.documents.slice(0, 5);
            }
        },
        toggleCategory(id) {
            this.extendedCategories[id] = !this.extendedCategories[id];
        }
    }
}

</script>

<template>
    <div class="filters">
        <div v-if="categories && categories.length > 1" class="filter-column">
            <div class="caption">{{ $s("STR_DOCUMENT_TYPE") }}</div>
            <select class="select" v-model="currentCategory">
                <option :value="null">{{ $s("STR_NOT_SELECTED") }}</option>
                <option v-for="category in categories" :key="category.id" :value="category.id">{{ category.title }}</option>
            </select>
        </div>
        <div v-if="years && years.length > 0" class="filter-column">
            <div class="caption">{{ $s("STR_DISTRIBUTION_YEAR") }}</div>
            <select class="select" v-model="currentYear">
                <option :value="null">{{ $s("STR_NOT_SELECTED") }}</option>
                <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
            </select>
        </div>
    </div>
    <template v-if="filteredDocumentsByCategory && filteredDocumentsByCategory.length > 0">
        <template v-for="category in filteredDocumentsByCategory">
            <div v-if="filteredDocumentsByCategory.length > 1" class="block-category-title">{{ category.title }}</div>
            <template v-for="document in getCategoryDocuments(category)">
                <a class="documents-tile small" :href="'/download/files/' + document.filename" target="_blank" n:attr="data-fancybox: isImage($file['filename']) ? true : null, download: isImage($file['filename']) ? null : ($file['name'] ?: true)">
                    <div class="title">{{ document.title }}</div>
                    <svg-icon class="icon" name="download"/>
                </a>
            </template>
            <button v-if="category.documents && category.documents.length > 5" class="link-button" @click="toggleCategory(category.id)">
                {{ this.extendedCategories[category.id] ? $s("STR_HIDE") : $s("STR_SHOW_ALL") }}
            </button>
        </template>
    </template>
</template>

<style lang="scss">

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:documents
</style>
